
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import Aside from '@devsisters/ui-admin/lib/Aside';
import AsideItem from '@devsisters/ui-admin/lib/AsideItem';
import AppBar from '@devsisters/ui-admin/lib/AppBar';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"aside"}}>{`Aside`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import Aside from '@devsisters/ui-admin/lib/Aside';
`}</MDXTag></MDXTag>
<Playground __position={0} __code={'<AppBar title=\"관리자\" />\n<Aside>\n  <AsideItem>관리자 1</AsideItem>\n  <AsideItem>관리자 2</AsideItem>\n  <AsideItem isActivated>관리자 3</AsideItem>\n</Aside>'} __scope={{props: this ? this.props : props,State,Aside,AsideItem,AppBar}}>
  <AppBar title="관리자" />
  <Aside>
    <AsideItem>관리자 1</AsideItem>
    <AsideItem>관리자 2</AsideItem>
    <AsideItem isActivated>관리자 3</AsideItem>
  </Aside>
</Playground>
           </MDXTag>
  }
}
  